import '../css/home.scss';

import Swiper, {
	Autoplay,
	HashNavigation,
	Keyboard,
	Navigation,
	Pagination,
} from 'swiper';

import { enableSwiperFormation } from './components/swiperFormation';
import gsap from 'gsap';
import Selectric from 'selectric';

document.addEventListener('DOMContentLoaded', () => {
	$('#select-events-home').selectric();

	enableSwiperFormation();

	// --------------------------------------------------------------------------------
	//  HOME MAPS SVG  LIST CAMPUS
	// --------------------------------------------------------------------------------

	// height campus card, in home maps
	function sizeCampusCard() {
		if (document.querySelector('.wrapper-infos-campus') !== null) {
			var partContent = $('.wrapper-infos-campus');
			partContent.removeAttr('style');
			$('.wrapper-infos-campus .campus-card').removeAttr('style');

			var mapHeight = $('.campus-map-bloc .wrapper-map').outerHeight();

			var sizeCard = [];
			$('.campus-card').each(function (i) {
				sizeCard.push($(this).outerHeight());
			});

			var maxSize = sizeCard.reduce(function (a, b) {
				return Math.max(a, b);
			});

			if ($(window).width() >= 768) {
				if (maxSize <= mapHeight) {
					partContent.css('height', mapHeight);
					$('.wrapper-infos-campus .campus-card').css('height', '100%');
				} else {
					partContent.css('height', maxSize);
					$('.wrapper-infos-campus .campus-card').css('height', '100%');
				}
			} else {
				partContent.css('height', maxSize);
				$('.wrapper-infos-campus .campus-card').css('height', '100%');
			}
		}
	}
	sizeCampusCard(); // on resize too

	window.addEventListener('resize', function () {
		sizeCampusCard();
	});

	if (document.querySelector('.home .wrapper-infos-campus')) {
		$(document).on('click', '.wrapper-map .icone', function (e) {
			var campus_name = $(this).parent().attr('id');
			$('.icon-campus').removeClass('active-icon-campus');
			$('#' + campus_name).addClass('active-icon-campus');
			var campusCardHide = $('.wrapper-infos-campus .visible-campus');
			var campusCardShow = $('.wrapper-infos-campus #' + campus_name);
			if (!campusCardShow.hasClass('visible-campus')) {
				var slideBg = gsap.timeline({ defaults: { ease: 'Power1.out' } });
				slideBg
					.fromTo(
						campusCardHide,
						{ duration: 0.5, x: 0 },
						{ x: '-100%', zIndex: 0 }
					)
					.fromTo(
						campusCardShow,
						{ duration: 0.5, x: '100%' },
						{ x: 0, zIndex: 1 },
						'0'
					)
					.add(
						$('.wrapper-infos-campus .visible-campus').removeClass(
							'visible-campus'
						)
					)
					.add(
						$('.wrapper-infos-campus #' + campus_name).addClass(
							'visible-campus'
						)
					);
			}
		});
	}

	// --------------------------------------------------------------------------------
	// slider home events
	// --------------------------------------------------------------------------------

	initSwiperEventsHome();

	function initSwiperEventsHome() {
		// Disable select no event
		$('#select-events-home option').each(function (index) {
			if (
				$(".swiper-events-home [data-filter='" + $(this).val() + "']").length ==
					0 &&
				index != 0
			) {
				$(this).prop('disabled', 'disabled');
				$(
					'.events-home-container-select .selectric-scroll ul li[data-index="' +
						index +
						'"]'
				).addClass('disabled');
			}
		});

		var eventsHomes = document.getElementsByClassName('swiper-events-home');
		if (eventsHomes.length > 0) {
			eventsHomes[0].children[0].classList.add('swiper-wrapper');

			var swiperArgs = {
				modules: [Navigation, Pagination, HashNavigation, Autoplay, Keyboard],
				slidesPerView: 1,
				slidesPerGroup: 1,
				autoHeight: false,
				spaceBetween: 10,
				pagination: {
					el: document.querySelector('#home-events .swiper-pagination'),
					clickable: true,
					dynamicBullets: true,
					dynamicMainBullets: 8,
				},
				loop: true,
				autoplay: {
					delay: 5000,
					disableOnInteraction: true,
				},
				navigation: {
					nextEl: document.querySelector('#home-events .swiper-button-next'),
					prevEl: document.querySelector('#home-events .swiper-button-prev'),
				},
				breakpoints: {
					768: {
						slidesPerView: 2,
						slidesPerGroup: 2,
					},

					1200: {
						spaceBetween: 0,
						slidesPerView: 1,
						slidesPerGroup: 1,
					},
				},
			};

			// init
			var swiperEvents = new Swiper('.swiper-events-home', swiperArgs);

			// change action
			$('#select-events-home').on('change', function () {
				gsap.fromTo(
					'.swiper-events-home',
					{ opacity: 1 },
					{ opacity: 0, duration: 1 }
				);

				var filters = $(this).val();

				var is_all = false;
				var data_filter = '';
				var i = 0;

				filters.forEach(filter => {
					if (filter == 'all') {
						is_all = true;
						return false; // breaks
					} else {
						if (i > 0) {
							data_filter += ', ';
						}
						data_filter += ".swiper-events-home [data-filter='" + filter + "']";
						i++;
					}
				});

				if (is_all || $(data_filter).length == 0) {
					$('.swiper-events-home [data-filter]')
						.removeClass('non-swiper-slide')
						.addClass('swiper-slide')
						.show();
				} else {
					$('.swiper-events-home .swiper-slide')
						.addClass('non-swiper-slide')
						.removeClass('swiper-slide')
						.hide();
					$(data_filter)
						.removeClass('non-swiper-slide')
						.addClass('swiper-slide')
						.attr('style', null)
						.show();
				}

				swiperEvents.destroy();
				swiperEvents = new Swiper('.swiper-events-home', swiperArgs);

				gsap.fromTo(
					'.swiper-events-home',
					{ opacity: 0 },
					{ opacity: 1, duration: 1 }
				);
			});
		}
	}
});
